export class LocationAttributeOrder {
    SourceAttributeId: string;
    SourceAttributeOrder: number;
    DestinationAttributeId: string;
    DestinationAttributeOrder: number;
}
